<template>
  <div
    :class="`${height} ${margin}`"
    class="inline-flex items-center justify-center leading-none"
  >
    <v-popover offset="8" class="info" :open="isOpen">
      <button
        type="button"
        class="text-base font-medium focus:outline-none tooltip-target"
        @mouseenter="handleShow"
        @mouseleave="handleDelayedHide"
      >
        <p
          v-if="color == 'white'"
          class="flex items-center justify-center w-6 h-6 text-sm font-extrabold bg-white border border-white rounded-full tmsk-blue-text"
        >
          ?
        </p>
        <p
          v-else
          class="flex items-center justify-center w-6 h-6 text-sm text-white border border-white rounded-full tmsk-blue-bg"
        >
          ?
        </p>
      </button>

      <template slot="popover">
        <div
          class="print:hidden"
          @mouseenter="handleShow"
          @mouseleave="handleDelayedHide"
        >
          <slot></slot>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { VPopover } from 'v-tooltip'
export default {
  name: 'Tooltip',
  components: {
    // VPopover
  },
  mixins: [],
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    height: {
      type: String,
      default: 'h-auto'
    },

    margin: {
      type: String,
      default: 'ml-4'
    },

    refToAttach: {
      type: String,
      default: ''
    },

    refFunction: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      isOpen: false,
      timeout: null
    }
  },
  computed: {
    ...mapGetters(['activeBreakpoint'])
  },
  watch: {
    isOpen (newValue) {
      if (newValue && this.refToAttach && this.refFunction) {
        setTimeout(() => {
          document.querySelector('#' + this.refToAttach).addEventListener('click', this.refFunction)
        }, 200)
      }
    }
  },

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    addListenerToTooltip () {
      document.querySelector().addEventListener('mouseover', this.handleShow)
    },
    handleShow () {
      clearTimeout(this.timeout)
      this.timeout = null
      this.isOpen = true
    },
    handleDelayedHide () {
      this.timeout = setTimeout(() => {
        this.isOpen = false
      }, 500)
    }
  }
}
</script>

<style>
</style>
